module.exports = __webpack_public_path__ + "static/media/sample-product.cf8c511f.svg";